import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Switch from "react-switch";
import CustomDateTimePicker from "../../common/DateTimePicker/RangeDateTimePicker";
// Api
import CommonApis from "../../../helper/common.api";
import TournamentApis from "../../../helper/tournament.api";

// Css
import "../../../styles/Tournaments.css";
import pc from "../../../images/games/pc.png";
import mobile from "../../../images/games/mobile.png";
import nintendo from "../../../images/games/nintendo.png";
import ps from "../../../images/games/ps.png";
import xbox from "../../../images/games/xbox.png";
import location from "../../../images/games/location.png";
import facebookGaming from "../../../images/games/facebook-gaming.png";
import instagram from "../../../images/games/instagram.png";
import loco from "../../../images/games/loco.png";
import telegram from "../../../images/games/telegram.png";
import twitter from "../../../images/games/twitter.png";
import youtube from "../../../images/games/youtube.png";
import twitch from "../../../images/games/twitch.png";
import fbInline from "../../../images/games/facebook-inline.png";
import instaInline from "../../../images/games/insta-inline.png";
import locoInline from "../../../images/games/loco-inline.png";
import telegramInline from "../../../images/games/telegram-inline.png";
import twitchInline from "../../../images/games/twitch-inline.png";
import twitterInline from "../../../images/games/twitter-inline.png";
import youtubeInline from "../../../images/games/youtube-inline.png";
// Icon
import {
  AiOutlineCloudUpload,
  AiFillCloseCircle,
  AiFillPlusCircle,
  AiOutlineLock,
  AiOutlineMinusCircle,
} from "react-icons/ai";
import { IoGolf, IoArrowBackCircleOutline, IoKeypad } from "react-icons/io5";
import { IoIosCheckmarkCircle, IoIosCloseCircleOutline, IoIosPeople } from "react-icons/io";
import { RiWhatsappFill, RiFacebookFill } from "react-icons/ri";
import { FaSearch, FaGlobeAfrica, FaUserAlt, FaTelegramPlane, FaTwitch } from "react-icons/fa";
import { BsTelephoneFill, BsInfoCircle, BsArrowRight } from "react-icons/bs";
import { CgMenuGridR } from "react-icons/cg";
import { FaXTwitter } from "react-icons/fa6";
import { AiFillInstagram, AiFillYoutube } from "react-icons/ai";

import { NavLink } from "react-router-dom";

// Utils
import { profile } from "../../../utils/localstorage.utils";
import {
  capitalize,
  errorHandler,
  is_Natural,
  regions,
  getWebData,
} from "../../../utils/common.utils";
import TeamApis from "../../../helper/teams.api";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { getAllGamesDetails } from "../../../utils/Games.utils";
import { ASSETS } from "../../../utils/Strings.utils";
import { setAllGames } from "../../../redux/actions/commonActions";
import { setTournamentDetails } from "../../../redux/actions/tournametActions";
import {
  baseUrls,
  handleTypes,
  getPlatformDetails,
  validateSocialMediaUrl,
  generateSocialMediaPlaceholders,
  generateSocialMediaErrorMessages,
} from "../../../utils/socialmedia.utils";
import { tournamentNameYupValidation } from "../../../utils/TournamentNameValidation.utils";

const mapStateToProps = props => {
  return {
    games: props.gameData,
    tournamentData: props.tournamentData,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    dispatchData: (data, key) => {
      switch (key) {
        case "game":
          dispatch(setAllGames(data));
          break;
        case "tournament":
          dispatch(setTournamentDetails(data));
          break;
        default:
          break;
      }
    },
  };
};

// Define platformsArray
const platformsArray = [
  { url: pc, name: "PC", value: "PC" },
  { url: mobile, name: "MOBILE", value: "MOBILE" },
  { url: nintendo, name: "SWITCH", value: "SWITCH" },
  { url: ps, name: "PLAYSTATION", value: "PLAYSTATION" },
  { url: xbox, name: "XBOX", value: "XBOX" },
];

class CreateTournament extends Component {
  socialMediaArray = [
    {
      id: "instagram",
      value: "",
      isChecked: false,
      url: instagram,
      error: "",
      inlineUrl: instaInline,
      label: "Instagram",
    },
    {
      id: "facebook",
      value: "",
      isChecked: false,
      url: facebookGaming,
      error: "",
      inlineUrl: fbInline,
      label: "Facebook",
    },
    {
      id: "x",
      value: "",
      isChecked: false,
      url: twitter,
      error: "",
      inlineUrl: twitterInline,
      label: "X",
    },
    {
      id: "twitch",
      value: "",
      isChecked: false,
      url: twitch,
      error: "",
      inlineUrl: twitchInline,
      label: "Twitch",
    },
    {
      id: "telegram",
      value: "",
      isChecked: false,
      url: telegram,
      error: "",
      inlineUrl: telegramInline,
      label: "Telegram",
    },
    {
      id: "youtube",
      value: "",
      isChecked: false,
      url: youtube,
      error: "",
      inlineUrl: youtubeInline,
      label: "Youtube",
    },
    {
      id: "loco",
      value: "",
      isChecked: false,
      url: loco,
      error: "",
      inlineUrl: locoInline,
      label: "Loco",
    },
  ];
  commonApi = new CommonApis();
  tournamentApis = new TournamentApis();
  teamApi = new TeamApis();
  profile = profile();
  bannerUrl;
  gamesArray = [];

  constructor(props) {
    super(props);
    this.state = {
      tournamentBanner: null,
      bannerURL: "",
      socialMediaDetails: [],
      extraDetails: [...this.socialMediaArray],
      openSocialMediaModal: false,
      gamesArray: [],
      buttonValues: {
        category: "",
        game: "",
        platform: [],
        participant_type: "",
        competition_type: "",
      },
      formikDetails: {},
      checked: false,
      bio: props.match.params.id ? props.tournamentData?.bio : "",
      orgSocialDetails: props?.location?.state ? props.location.state : null,
      tournamentData: props.match.params.id ? props.tournamentData : {},
      searchInput: "",
      invalidImage: null,
      regions: regions,
      type: "BOTH",
      pType: "BOTH",
      countryCodes: [],
      selectedRegion: "",
    };

    // Initialize social media placeholders and error messages
    this.socialMediaPlaceholders = generateSocialMediaPlaceholders(baseUrls, handleTypes);
    this.socialMediaErrorMessages = generateSocialMediaErrorMessages(baseUrls, handleTypes);

    if (props?.match?.params?.id) {
      this.getData();
    }
    this.getCodes();
    getAllGamesDetails(this.setAllGamesDetails);
  }

  componentDidMount() {
    this.props.showOrHideNav(true);
    if (this.props.match.params.id) {
      if (!this.props?.tournamentData?._id) {
        this.getData();
      } else {
        this.initialSet(this.props.tournamentData);
      }
    }
  }

  setWebsiteData = res => {
    this.setState({ websiteData: res[0] });
  };

  setAllGamesDetails = response => {
    this.setState({ gamesArray: response });
  };

  getCodes = () => {
    this.props.updateLoader(true);
    this.commonApi
      .getCountryCodes()
      .then(res => {
        this.props.updateLoader(false);
        this.setState({ countryCodes: res.data.result });
      })
      .catch(err => {
        this.props.updateLoader(false);
        errorHandler(err);
      });
  };

  //handle All button value changes
  handleChange = (e, key, val, type) => {
    e.preventDefault();
    const isUpdate = this.state?.orgSocialDetails?.to === "Update" ? true : false;
    if (type === 1 && isUpdate) {
      toast.error("Edit access denied.", { autoClose: 3000 });
      return false;
    }
    let data = this.state.buttonValues;
    if (key === "game") {
      let values = this.state.buttonValues;
      values.platform = [];
      this.setState({
        buttonValues: values,
        regions: val.regions,
        type: val.gameType,
        pType: val.participantType,
      });
    }
    if (key === "platform") {
      let platformData = this.state.buttonValues?.platform ? this.state.buttonValues?.platform : [];
      if (platformData.includes(val)) {
        let i = platformData.indexOf(val);
        platformData.splice(i, 1);
      } else {
        platformData.push(val);
      }
      data.platform = platformData;
      this.setState({ buttonValues: data });
    } else {
      data[key] = val;
      this.setState({ buttonValues: data });
    }
  };

  //upload banner image
  onBannerChange = event => {
    this.setState({
      invalidImage: null,
    });

    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      if (!img.name.match(/\.(jpg|jpeg|png)$/)) {
        toast.warning("Please select a valid image type.");
        return false;
      }
      this.setState({
        bannerURL: URL.createObjectURL(img),
      });

      const formData = new FormData();
      formData.append("file", event.target.files[0]);
      this.props.updateLoader(true);
      this.commonApi
        .uploadSingleImg(formData)
        .then(response => {
          this.setState({
            tournamentBanner: response.data.result,
          });
          this.props.updateLoader(false);
        })
        .catch(err => {
          toast.error("Failed to upload tournament image");
          this.props.updateLoader(false);
        });
    }
  };

  triggerInputFile = () => this.fileInput.click();

  //to append org social contacts in tournament
  appendOrgDetails = e => {
    this.setState({ checked: !this.state.checked });
    if (!this.state.orgSocialDetails.contact) {
      toast.error("There is no contact details in organization");
      this.setState({ checked: false });
      return false;
    }
    let data = this.state.extraDetails;
    let incoming = this.state.orgSocialDetails.contact;
    if (this.state.checked) {
      for (let key in incoming) {
        let index = data
          .map(el => {
            return el.id;
          })
          .indexOf(key);
        if (index >= 0) {
          data[index].value = "";
          data[index].isChecked = false;
        }
      }
    } else {
      for (let key in incoming) {
        let index = data
          .map(el => {
            return el.id;
          })
          .indexOf(key);
        if (index >= 0) {
          data[index].value = incoming[key];
          data[index].isChecked = true;
        }
      }
    }
    this.setState({ extraDetails: data, socialMediaDetails: data });
  };

  showFields = (e, i, type) => {
    e.preventDefault();
    const newArray = [...this.state.extraDetails];
    let temp = { ...newArray[i] };
    temp.isChecked = type;
    if (type === false) {
      temp.value = "";
      temp.error = "";
    }
    newArray[i] = temp;
    this.setState({
      extraDetails: newArray,
      socialMediaDetails: newArray.filter(detail => detail.isChecked && detail.value !== ""),
    });
  };

  updateDetails = (e, i) => {
    let { extraDetails } = this.state;
    extraDetails[i].value = e.target.value;

    // Validate URL immediately when user types
    if (extraDetails[i].value !== "") {
      extraDetails[i].error = validateSocialMediaUrl(extraDetails[i].value, extraDetails[i].id);
    } else {
      extraDetails[i].error = "";
    }

    this.setState({ extraDetails });
  };

  getAddButton = () => {
    const { extraDetails } = this.state;
    return extraDetails.some(detail => detail.isChecked);
  };

  // Get platform details (regex, placeholder, error message)
  getPlatformDetails = key => {
    const platform = key.toLowerCase();
    // Map 'facebook' key to 'facebookgaming' for consistency
    const effectivePlatform = platform === "facebook" ? "facebookgaming" : platform;
    return {
      regex: this.socialMediaRegex[effectivePlatform],
      placeholder: this.socialMediaPlaceholders[effectivePlatform],
      errorMessage: this.socialMediaErrorMessages[effectivePlatform] || "Enter a valid url",
    };
  };

  validateDetails = () => {
    let errors = 0;
    const filledFields = this.state.extraDetails.map(field => {
      let error = "";
      if (field.value !== "") {
        error = validateSocialMediaUrl(field.value, field.id);
      }
      if (error) {
        errors++;
      }
      return { ...field, error };
    });

    this.setState({ extraDetails: filledFields, socialMediaDetails: filledFields });
    if (errors > 0) {
      toast.error("Please fix the social media URL errors before proceeding");
      return false;
    } else {
      return true;
    }
  };

  addDetails = () => {
    if (this.validateDetails()) {
      this.setState({
        openSocialMediaModal: !this.state.openSocialMediaModal,
      });
    }
  };

  saveFormikDetails = (value, key, type) => {
    const isUpdate = this.state?.orgSocialDetails?.to === "Update" ? true : false;

    // For date fields, the RangeDateTimePicker now handles most validation
    // Only check if the date is in the past for immediate feedback
    if (
      key === "RegStartDate" ||
      key === "RegEndDate" ||
      key === "tourStartDate" ||
      key === "tourEndDate"
    ) {
      if (value && value < new Date()) {
        return false;
      }
    }

    if (type === 1 && isUpdate) {
      toast.error("Edit access denied.", { autoClose: 3000 });
      return false;
    }

    let data = this.state.formikDetails;
    data[key] = value;

    this.setState({ formikDetails: data });
  };
  // updateGameSearch = (e) => {
  //     e.preventDefault()
  //     const newGamesArray = this.gamesArray.filter(game => game.name.toLowerCase().includes(e.target.value.toLowerCase()))
  //     this.setState({
  //         gamesArray: newGamesArray
  //     })
  // }

  //Get data to patch for update tournament
  getData() {
    const data = {
      _id: this.props.match.params.id,
    };

    this.props.updateLoader(true);

    this.tournamentApis
      .getTournaments(data)
      .then(res => {
        this.props.dispatchData(res.data.result[0], "tournament");
        this.initialSet(res.data.result[0]);
        if (!this.state?.tournamentDetails) {
          this.props.history.push("/pageNotFound");
        }
        this.props.updateLoader(false);
      })
      .catch(err => {
        this.props.updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  }

  initialSet = data => {
    let result = data;
    this.setState({
      tournamentDetails: result,
    });

    let formikDetails = {
      name: result.name,
      description: result?.bio,
      whatsappNo: result.contactDetails?.whatsapp,
      discord: result.contactDetails?.discord,
      maxParticipants: result?.maxParticipant,
      participantsPerTeam: result?.participantsPerTeam ? result.participantsPerTeam : "",
      region: result?.region,
      RegStartDate: result?.registrationStartTime,
      RegEndDate: result?.registrationEndTime,
      tourStartDate: result?.tournamentStartTime,
      tourEndDate: result?.tournamentEndTime,
    };
    let buttonValues = {
      category: result.visibility,
      game: result.gameDetails, //this.state.gamesArray?.filter(game => game?._id === result.gameId)?.[0],
      platform: result.platform,
      participant_type: result.participantType,
      competition_type: result.competitionType,
    };
    let extraDetails = this.state.extraDetails;
    for (let key in result.contactDetails) {
      let index = extraDetails
        .map(el => {
          return el.id;
        })
        .indexOf(key);
      if (index >= 0) {
        extraDetails[index].value = result.contactDetails[key];
        extraDetails[index].isChecked = true;
      }
    }
    this.setState({
      tournamentBanner: result.baner,
      formikDetails: formikDetails,
      buttonValues: buttonValues,
      extraDetails: extraDetails,
      socialMediaDetails: extraDetails,
      tournamentData: result,
      bannerURL:
        result.baner && result.gameDetails?.logo && result.baner.url !== result.gameDetails.logo.url
          ? result.baner.url
          : "",
      regions: result.gameDetails.regions,
      type: result.gameDetails.gameType,
      pType: result.gameDetails.participantType,
      selectedRegion: result.gameDetails.regions ? result.gameDetails.regions[0] : "",
    });
  };

  //To create tournament
  createTournament = values => {
    if (!values.region) {
      toast.error("Region is required");
      return false;
    }

    if (!values.whatsappNo && !values.discord) {
      toast.error("Either WhatsApp number or Discord ID is required");
      return false;
    }

    if (new Date(values.RegStartDate) < new Date()) {
      toast.error("Registration start date cannot be in the past");
      return false;
    }

    if (new Date(values.RegStartDate) > new Date(values.RegEndDate)) {
      toast.error("Registration start date cannot be greater than registration end date");
      return false;
    }

    const regEndDate = new Date(values.RegEndDate);
    const tourStartDate = new Date(values.tourStartDate);

    // Check if tournament start is before registration end
    if (tourStartDate <= regEndDate) {
      toast.error("Tournament start time must be after registration end time");
      return false;
    }

    if (new Date(values.tourStartDate) > new Date(values.tourEndDate)) {
      toast.error("Tournament start date cannot be greater than tournament end date");
      return false;
    }

    if (new Date(values.RegEndDate) > new Date(values.tourEndDate)) {
      toast.error("Registration end date cannot be greater than tournament end date");
      return false;
    }

    for (let key in this.state.buttonValues) {
      if (key === "platform") {
        if (!this.state.buttonValues?.platform?.length) {
          toast.error(`${key} is required`);
          return;
        }
      } else {
        if (!this.state.buttonValues[key]) {
          toast.error(`${capitalize(key.replace("_", " "))} is required`);
          return;
        }
      }
    }

    const data = {
      organizationId: this.props.match.params.orgId,
      name: values.name,
      bio: values.description,
      baner: this.state.tournamentBanner ? this.state.tournamentBanner : null,
      gameId: this.state.buttonValues?.game._id,
      contactDetails: {
        whatsapp: values.whatsappNo ? { code: values.countryCode, number: values.whatsappNo } : "",
        discord: values.discord ? values.discord : "",
      },
      platform: this.state.buttonValues?.platform,
      ...(values.region && { region: values.region }),
      participantType: this.state.buttonValues.participant_type,
      maxParticipant: values.maxParticipants,
      //participantsPerTeam: values.participantsPerTeam,
      competitionType: this.state.buttonValues.competition_type,
      visibility: this.state.buttonValues.category,
      listingType: !this.props.match.params.id ? "free" : this.tournamentData?.listingType,
      teams: !this.props.match.params.id ? [] : this.tournamentData?.teams,
      // leaderBoard: !this.props.match.params.id ? {} : this.tournamentData?.leaderBoard,
      duration: !this.props.match.params.id ? {} : this.tournamentData?.duration,
      registrationStatus: !this.props.match.params.id
        ? "DRAFT"
        : this.tournamentData?.registrationStatus,
      isDeleted: !this.props.match.params.id ? false : this.tournamentData?.isDeleted,
      registrationStartTime: new Date(values.RegStartDate).toUTCString(),
      registrationEndTime: new Date(values.RegEndDate).toUTCString(),
      tournamentStartTime: new Date(values.tourStartDate).toUTCString(),
      tournamentEndTime: new Date(values.tourEndDate).toUTCString(),
      stages: !this.props.match.params.id ? [] : this.tournamentData?.stages,
      entryFeeAndPrizeDetails: !this.props.match.params.id
        ? { entryFee: false, entryFeeAmount: 0 }
        : this.tournamentData?.entryFeeAndPrizeDetails,
    };
    if (this.state.buttonValues?.participant_type === "TEAM") {
      data["participantsPerTeam"] = values.participantsPerTeam;
    }
    for (let i = 0; i < this.state.socialMediaDetails.length; i++) {
      if (this.state.socialMediaDetails[i]?.value) {
        data.contactDetails[this.state.socialMediaDetails[i].id] =
          this.state.socialMediaDetails[i]?.value;
      }
    }

    this.props.updateLoader(true);
    if (!this.props.match.params.id) {
      const params = {
        orgId: this.props.match.params.orgId,
      };
      this.tournamentApis
        .createTournamentV2(params, data)
        .then(res => {
          this.props.updateLoader(false);
          toast.success("Tournament created successfully");
          this.props.history.push({
            pathname: `/organization/${res.data.result.organizationId}/tournament/${res.data.result._id}/overview`,
            state: { orgId: res.data.result.organizationId },
          });
        })
        .catch(err => {
          this.props.updateLoader(false);
          errorHandler(err, this.props.logout);
        });
    } else {
      const params = {
        orgId: this.props.match.params.orgId,
        tournamentId: this.props.match.params.id,
      };
      this.tournamentApis
        .updateTournamentsv2(params, this.props.match.params.id, data)
        .then(res => {
          this.props.dispatchData(res.data.result, "tournament");
          this.props.updateLoader(false);
          toast.success("Tournament updated successfully");
          this.props.history.push({
            pathname: `/organization/${res.data.result.organizationId}/tournament/${res.data.result._id}/overview`,
            state: {
              orgId: res.data.result.organizationId,
              tournamentDetails: res.data.result,
            },
          });
          this.props.history.push();
        })
        .catch(err => {
          this.props.updateLoader(false);
          errorHandler(err, this.props.logout);
        });
    }
  };

  maxParticipantVal = val => {
    let error;
    let number = parseFloat(val);
    if (number === 1) {
      error = "Max participants should be more than one";
    }
    if (!is_Natural(number)) {
      error = `Invalid input value`;
    } else if (number && (number & (number - 1)) !== 0) {
      error = `Max participants should be in form of 2,4,8,16...`;
    }
    return error;
  };
  render() {
    const { gamesArray, invalidImage, searchInput, type, place, effect, pType } = this.state;
    const isUpdate = this.state?.orgSocialDetails?.to === "Update" ? true : false;
    const regStart = this.state.formikDetails?.RegStartDate
      ? new Date(this.state.formikDetails?.RegStartDate)
      : new Date();
    const currentTime = new Date();
    const isPastRegStart = currentTime > regStart;
    let isFFA = type === "FFA" || type === "BOTH";
    let isDUEL = type === "DUEL" || type === "BOTH";
    let isSINGLE = pType === "SINGLE" || pType === "BOTH";
    let isTEAM = pType === "TEAM" || pType === "BOTH";
    let code = "+91";
    let mobile;
    if (this.state.orgSocialDetails?.to === "Create") {
      if (!this.state.isChecked) {
        code = this.state.orgSocialDetails?.contact?.whatsapp?.code;
        mobile = this.state.orgSocialDetails?.contact?.whatsapp?.number;
      } else {
        mobile = "";
      }
    } else {
      code = this.state.formikDetails?.whatsappNo?.code;
      mobile = this.state.formikDetails?.whatsappNo?.number;
    }
    const requiredObject = getWebData();
    return (
      <>
        {/* Two component handle from create tournament
            1. create tournament page
            2. Tournament basic details page*/}

        {this.state.gamesArray?.length ? (
          <section className="body-section create-tournament-page">
            <div className="container p-3 mt-lg-3">
              {this.props?.match?.params?.id && (
                <div>
                  <IoArrowBackCircleOutline
                    onClick={() => this.props.history.goBack()}
                    className="back-btn mt-2"
                  />
                  <NavLink
                    className="text-white"
                    to={{
                      pathname: `/organization/${this.props.match.params.orgId}/tournament/${this.props.match.params.id}/overview`,
                      state: {
                        isConfig: true,
                      },
                    }}
                  >
                    <CgMenuGridR className="fs-20 float-end" />
                  </NavLink>
                </div>
              )}

              <div className="d-flex flex-row justify-content-center mb-3">
                <IoGolf className="btn-size-20 me-2 mb-1" />
                <h1 className="fs-20 fw-bold" style={{ marginBottom: 0 }}>
                  {this.state?.orgSocialDetails?.to ? this.state?.orgSocialDetails?.to : "Create"}{" "}
                  Tournament
                </h1>
                {/* <h1 className="clan-heading" style={{ marginBottom: 0 }}>Basic Details</h1> */}
              </div>

              <Formik
                enableReinitialize
                initialValues={{
                  name: this.state.formikDetails?.name ? this.state.formikDetails.name : "",
                  description: this.state.formikDetails?.description
                    ? this.state.formikDetails.description
                    : "",
                  whatsappNo: mobile,
                  discord: profile()?.discordProfile?.discordUsername
                    ? profile()?.discordProfile?.discordUsername
                    : "",
                  maxParticipants: this.state.formikDetails?.maxParticipants
                    ? this.state.formikDetails.maxParticipants
                    : "",
                  region: this.state.selectedRegion
                    ? this.state.selectedRegion
                    : this.props.match.params.id && this.props.tournamentData?.region
                      ? this.props.tournamentData.region
                      : "",
                  RegStartDate: this.state.formikDetails?.RegStartDate
                    ? this.state.formikDetails.RegStartDate
                    : "",
                  RegEndDate: this.state.formikDetails?.RegEndDate
                    ? this.state.formikDetails.RegEndDate
                    : "",
                  tourStartDate: this.state.formikDetails?.tourStartDate
                    ? this.state.formikDetails.tourStartDate
                    : "",
                  tourEndDate: this.state.formikDetails?.tourEndDate
                    ? this.state.formikDetails.tourEndDate
                    : "",
                  countryCode: this.state.formikDetails?.countryCode
                    ? this.state.formikDetails.countryCode
                    : code,
                  participantsPerTeam: this.state.formikDetails?.participantsPerTeam
                    ? this.state.formikDetails.participantsPerTeam
                    : this.state.buttonValues.game
                      ? this.state.buttonValues?.game?.participantsAllowedPerTeam[0]
                      : "",
                }}
                validationSchema={Yup.object({
                  name: Yup.string()
                    .trim()
                    .required("Tournament name is required")
                    .max(25, "Max 25 characters")
                    .matches(...tournamentNameYupValidation().matches),
                  description: Yup.string()
                    .required("Tournament description is required")
                    .max(250, "Max 250 characters"),
                  whatsappNo: Yup.string()
                    .matches(/^[0-9]*$/, "only numerics allowed")
                    .min(9, "min 9 digits required")
                    .max(12, "max 12 digits allowed"),
                  // discord: Yup.string().matches(/^.{3,32}#[0-9]{4}$/, 'Invalid Username'),
                  discord: Yup.string(),
                  RegStartDate: Yup.date()
                    .required("Registration Start time and End time is required")
                    .min(new Date(), "Start time must be greater than the current time"),
                  RegEndDate: Yup.date().min(
                    Yup.ref("RegStartDate"),
                    "End time can't be before start date"
                  ),
                  tourStartDate: Yup.date()
                    .required("Tournament Start time and End time is required")
                    .test(
                      "is-after-reg-end",
                      "Tournament start time must be after registration end time",
                      function (value) {
                        const { RegEndDate } = this.parent;
                        return !RegEndDate || !value || new Date(value) > new Date(RegEndDate);
                      }
                    ),
                  tourEndDate: Yup.date().min(
                    Yup.ref("tourStartDate"),
                    "Can't end before tournament start time"
                  ),
                  maxParticipants: Yup.number()
                    .required("Enter Max participants allowed")
                    .oneOf(
                      [2, 4, 8, 16, 32, 64, 128, 256, 512, 1024, 2048],
                      "Choose a valid participant count"
                    ),
                  participantsPerTeam: Yup.number(),
                })}
                onSubmit={(values, { setSubmitting }) => {
                  setTimeout(() => {
                    this.createTournament(values);
                    setSubmitting(false);
                  }, 400);
                }}
                onChange={values => {
                  this.getMicroWeb(values);
                }}
              >
                <Form className="row create-tournament-form m-1" autoComplete="off">
                  <div className="col-lg-6 col-12 p-lg-4">
                    <div className="col-lg-4 col-md-4 col-7 m-auto">
                      <div className="uploadWithPreview">
                        <div className="upload-section cursor-pointer">
                          <input
                            type="file"
                            id="upload_file"
                            accept=".png, .jpg, .jpeg"
                            hidden
                            ref={fileInput => (this.fileInput = fileInput)}
                            onChange={this.onBannerChange}
                            name=""
                            className="image-input"
                          />
                          {this.state.bannerURL !== "" ? (
                            <div className="text-right flex-column text-end">
                              <AiFillCloseCircle
                                className="btn-size-20 position-absolute text-white"
                                style={{ marginLeft: "-10px", marginTop: "-10px" }}
                                onClick={() => {
                                  this.setState({ tournamentBanner: null, bannerURL: "" });
                                }}
                              />
                              <div className="after-uploaded-image" onClick={this.triggerInputFile}>
                                <img src={this.state.bannerURL} alt="" />
                              </div>
                            </div>
                          ) : (
                            <div className="before-uploaded-panel">
                              <div
                                className="upload-banner w-100 d-flex align-items-center justify-content-center"
                                onClick={this.triggerInputFile}
                              >
                                <div className="btn-size-30 d-flex flex-column justify-content-center">
                                  <AiOutlineCloudUpload className="btn-size-25 text-white-50 mx-auto" />
                                  <h1
                                    className="fs-16 fw-600 text-white-50"
                                    htmlFor="exampleInputText"
                                  >
                                    Banner
                                  </h1>
                                  <p className="fs-12 text-danger mb-0 fw-bold ">
                                    Dimensions: 456 X 300
                                  </p>
                                </div>
                              </div>
                            </div>
                          )}
                          {/* {invalidImage && (<p className="error-msg mwc-image-validation"> {invalidImage} </p>)} */}
                        </div>
                      </div>
                    </div>

                    <div className="mt-2">
                      <label htmlFor="name" className="fs-14 fw-600 text-white mb-1">
                        {" "}
                        Name
                      </label>
                      <Field
                        name="name"
                        type="text"
                        disabled={isUpdate}
                        className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                        placeholder="Enter Tournament Name"
                        onKeyUp={e => {
                          this.saveFormikDetails(e.target.value, "name", 1);
                        }}
                      />
                      <ErrorMessage component="span" className="error-msg" name="name" />
                    </div>
                    {/* description */}
                    <div className="mt-2">
                      <div className="d-flex justify-content-between">
                        <label htmlFor="description" className="fs-14 fw-600 text-white mb-1">
                          Description
                        </label>
                        <label className="fs-12 fw-bold text-white-50">
                          {this.state.formikDetails?.description?.length}/250
                        </label>
                      </div>
                      <Field
                        name="description"
                        type="text"
                        as="textarea"
                        maxLength={250}
                        rows="4"
                        disabled={isUpdate}
                        className="purple-field d-flex align-items-center w-100 border-0 p-2 text-white fs-14 no-resize"
                        placeholder="Enter Description"
                        onKeyUp={e => {
                          this.saveFormikDetails(e.target.value, "description", 1);
                          this.setState({ bio: e.target.value });
                        }}
                      />
                      <ErrorMessage component="span" className="error-msg" name="description" />
                    </div>

                    <div className="row mt-3">
                      <div className="col-12">
                        <div className="form-group mb-3">
                          <label className="fs-14 fw-600 text-white" htmlFor="registrationDate">
                            Registration Dates
                          </label>
                          <CustomDateTimePicker
                            startDate={
                              this.state.formikDetails?.RegStartDate
                                ? new Date(this.state.formikDetails.RegStartDate)
                                : null
                            }
                            endDate={
                              this.state.formikDetails?.RegEndDate
                                ? new Date(this.state.formikDetails.RegEndDate)
                                : null
                            }
                            onChange={([start, end]) => {
                              // The RangeDateTimePicker now handles validation and auto-adjustment internally
                              this.saveFormikDetails(start, "RegStartDate", 1);
                              this.saveFormikDetails(end, "RegEndDate", 2);
                            }}
                            minDate={new Date(new Date().setMinutes(new Date().getMinutes() + 15))}
                            disabled={isPastRegStart && this.props.match.params?.id}
                          />
                          <ErrorMessage
                            component="span"
                            className="error-msg"
                            name="RegStartDate"
                          />
                          <ErrorMessage component="span" className="error-msg" name="RegEndDate" />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group">
                          <label className="fs-14 fw-600 text-white" htmlFor="tournamentDate">
                            Tournament Dates
                          </label>
                          <CustomDateTimePicker
                            startDate={
                              this.state.formikDetails?.tourStartDate
                                ? new Date(this.state.formikDetails.tourStartDate)
                                : null
                            }
                            endDate={
                              this.state.formikDetails?.tourEndDate
                                ? new Date(this.state.formikDetails.tourEndDate)
                                : null
                            }
                            minStartTime={
                              this.state.formikDetails?.RegEndDate
                                ? new Date(this.state.formikDetails.RegEndDate)
                                : undefined
                            }
                            onChange={([start, end]) => {
                              const regEndDate = this.state.formikDetails?.RegEndDate
                                ? new Date(this.state.formikDetails.RegEndDate)
                                : new Date();

                              // Only check if tournament start is before or equal to registration end
                              // The RangeDateTimePicker handles time validation and auto-adjustment internally
                              if (start && start <= regEndDate) {
                                toast.error(
                                  "Tournament start time must be after registration end time.",
                                  { autoClose: 3000 }
                                );
                                this.saveFormikDetails(null, "tourStartDate", 2);
                              } else {
                                this.saveFormikDetails(start, "tourStartDate", 2);
                              }

                              this.saveFormikDetails(end, "tourEndDate", 2);
                            }}
                            minDate={
                              this.state.formikDetails?.RegEndDate
                                ? new Date(this.state.formikDetails.RegEndDate)
                                : new Date()
                            }
                            placeholderText="Select Dates & Time of Tournament"
                          />
                          <ErrorMessage
                            component="span"
                            className="error-msg"
                            name="tourStartDate"
                          />
                          <ErrorMessage component="span" className="error-msg" name="tourEndDate" />
                        </div>
                      </div>
                    </div>

                    <div className="my-3">
                      <div className="">
                        <label htmlFor="custom-btn" className="fs-14 fw-600 text-white mb-1">
                          {" "}
                          Category{" "}
                        </label>
                        <div
                          data-tooltip={
                            requiredObject.INFORMATION_TEXT?.CREATE_TOURNAMENT.CATEGORY ||
                            "Public: Anyone can join\nInvitational: Join by invite only"
                          }
                          className="tooltip-info cursor-pointer"
                        >
                          <BsInfoCircle className="btn-size-12 ms-1" />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <button
                            className={`pink-skyblue-gradient-btn w-100 height-55 border-0 ${this.state.buttonValues?.category === "PUBLIC" ? "epz-active-field" : ""}`}
                            onClick={e => this.handleChange(e, "category", "PUBLIC", 2)}
                          >
                            <FaGlobeAfrica className="btn-size-20 text-white" />
                            <h6 className="fs-12 fw-500 text-white mb-0">Public</h6>
                          </button>
                        </div>
                        <div className="col-6">
                          <button
                            className={`pink-skyblue-gradient-btn w-100 height-55 border-0 ${this.state.buttonValues?.category === "PRIVATE" ? "epz-active-field" : ""}`}
                            onClick={e => this.handleChange(e, "category", "PRIVATE", 2)}
                          >
                            <AiOutlineLock className="btn-size-20 text-white" />
                            <h6 className="fs-12 fw-500 text-white mb-0">Invitational</h6>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="my-3">
                      <h1 className="fs-14 fw-600 text-white mb-2">Games</h1>
                      <div
                        className=""
                        style={{
                          display: this.state?.orgSocialDetails?.to === "Update" ? "none" : "block",
                        }}
                      >
                        <input
                          type="search"
                          placeholder="Search Games..."
                          className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                          onChange={e => this.setState({ searchInput: e.target.value })}
                        />
                        <FaSearch
                          className="btn-size-20 me-3 position-relative float-end"
                          style={{ marginTop: "-30px" }}
                        />
                      </div>
                      <div className="row my-3">
                        {this.state.gamesArray.length &&
                        this.state.gamesArray.filter(games =>
                          games.name.toLowerCase().includes(this.state.searchInput.toLowerCase())
                        ).length ? (
                          this.state.gamesArray
                            .filter(games =>
                              games.name
                                .toLowerCase()
                                .includes(this.state.searchInput.toLowerCase())
                            )
                            ?.map((game, i) => {
                              if (game.isGameEnabled) {
                                return (
                                  <div className="col-6 col-md-4" key={i}>
                                    <div
                                      className={`tournament-game-card d-flex flex-column justify-content-center w-100 ${this.state.buttonValues?.game?._id === game._id ? "epz-active-field" : ""}`}
                                      onClick={e => {
                                        this.handleChange(e, "game", game, 1);
                                      }}
                                      style={{
                                        backgroundImage: `url(${game?.logo?.url || "https://placehold.co/400"})`,
                                      }}
                                    >
                                      {this.state.buttonValues?.game?._id === game._id ? (
                                        <IoIosCheckmarkCircle
                                          className="m-auto"
                                          style={{ height: "30px", width: "30px" }}
                                        />
                                      ) : null}
                                    </div>
                                  </div>
                                );
                              }
                            })
                        ) : (
                          <div className="text-center">
                            <img className="no-tour-found" src={ASSETS.EMPTY_COLLECTION} alt={""} />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-12 p-lg-4">
                    <div className="my-3 mt-lg-0">
                      <div className="d-flex" style={{ alignItems: "center" }}>
                        <hr className="border-1 flex-grow-1" style={{ height: "2px" }} />
                        <div className="d-flex mx-3" style={{ alignItems: "center" }}>
                          <BsTelephoneFill className="btn-size-20 me-2" />
                          <p className="fs-16 fw-bold text-white-50 mb-0">Contact Details</p>
                        </div>
                        <hr className="border-1 flex-grow-1" style={{ height: "2px" }} />
                      </div>
                      {!this.props.match.params.id && (
                        <div className="catalina-blue my-3 height-45 d-flex align-items-center">
                          <p className="fs-12 fw-600 mb-0 flex-grow-1 ps-3">
                            Use Organizaton's Details
                          </p>
                          <Switch
                            onChange={e => {
                              this.appendOrgDetails(e);
                            }}
                            checked={this.state.checked}
                            checkedIcon={false}
                            uncheckedIcon={false}
                            className="me-2"
                          />
                        </div>
                      )}
                    </div>
                    <div className="my-3">
                      <div className="">
                        <RiWhatsappFill
                          className="btn-size-20 text-white-50 ms-3 position-absolute"
                          style={{ marginTop: "12px" }}
                        />
                        <Field
                          name="countryCode"
                          as="select"
                          className="purple-field d-flex align-items-center w-100 border-0 ps-5 text-white fs-14 height-45"
                          onChange={e => {
                            this.saveFormikDetails(e.target.value, "countryCode", 2);
                          }}
                        >
                          {this.state.countryCodes.map((el, i) => {
                            return (
                              <option value={el.code} key={i}>{`${el.code} ${el.name}`}</option>
                            );
                          })}
                        </Field>
                        <div className="purple-field d-flex align-items-center w-100 border-0 text-white fs-14 height-45 mt-2">
                          <IoKeypad className="btn-size-20 text-white-50 ms-3" />
                          <Field
                            name="whatsappNo"
                            type="text"
                            className="text-white border-0 ms-3"
                            placeholder="Whatsapp number"
                            onKeyUp={e => {
                              this.saveFormikDetails(e, "whatsappNo", 2);
                            }}
                            style={{ backgroundColor: "transparent", flexGrow: 1, outline: "none" }}
                          />
                        </div>
                      </div>
                      <ErrorMessage component="span" className="error-msg" name="whatsappNo" />
                    </div>
                    {/* <div className="my-3">
                                            <div className="">
                                                <RiDiscordFill className="btn-size-20 text-white-50 ms-3 position-absolute" style={{ marginTop: '12px' }} />
                                                <Field
                                                    name="discord"
                                                    type="text"
                                                    disabled={true}
                                                    className="purple-field d-flex align-items-center w-100 border-0 ps-5 text-white fs-14 height-45"
                                                    placeholder="mike#1234"
                                                // onKeyUp={(e) => { this.saveFormikDetails(e, 'discord', 2) }}
                                                />
                                            </div>
                                            <ErrorMessage component="span" className="error-msg" name="discord" />
                                        </div> */}

                    {this.state.socialMediaDetails?.map((details, i) => {
                      if (details.value !== "" && details.error === "") {
                        return (
                          <div className="my-2" key={i}>
                            <h1 className="fs-14 fw-bold mt-2 text-white">
                              {capitalize(details.label)}
                            </h1>
                            <div
                              className="purple-field d-flex align-items-center w-100 border-0 position-relative"
                              style={{ paddingRight: "40px" }}
                            >
                              {/* Render React icon based on key, absolutely positioned inside input */}
                              {details.id === "instagram" && (
                                <AiFillInstagram
                                  className="position-absolute"
                                  style={{
                                    left: 12,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    width: 20,
                                    height: 20,
                                    color: "#fff",
                                    filter: "drop-shadow(0 0 4px #888)",
                                  }}
                                />
                              )}
                              {details.id === "facebook" && (
                                <RiFacebookFill
                                  className="position-absolute"
                                  style={{
                                    left: 12,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    width: 20,
                                    height: 20,
                                    color: "#fff",
                                    filter: "drop-shadow(0 0 4px #888)",
                                  }}
                                />
                              )}
                              {details.id === "x" && (
                                <FaXTwitter
                                  className="position-absolute"
                                  style={{
                                    left: 12,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    width: 20,
                                    height: 20,
                                    color: "#fff",
                                    filter: "drop-shadow(0 0 4px #888)",
                                  }}
                                />
                              )}
                              {details.id === "twitch" && (
                                <FaTwitch
                                  className="position-absolute"
                                  style={{
                                    left: 12,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    width: 20,
                                    height: 20,
                                    color: "#fff",
                                    filter: "drop-shadow(0 0 4px #888)",
                                  }}
                                />
                              )}
                              {details.id === "telegram" && (
                                <FaTelegramPlane
                                  className="position-absolute"
                                  style={{
                                    left: 12,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    width: 20,
                                    height: 20,
                                    color: "#fff",
                                    filter: "drop-shadow(0 0 4px #888)",
                                  }}
                                />
                              )}
                              {details.id === "youtube" && (
                                <AiFillYoutube
                                  className="position-absolute"
                                  style={{
                                    left: 12,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    width: 20,
                                    height: 20,
                                    color: "#fff",
                                    filter: "drop-shadow(0 0 4px #888)",
                                  }}
                                />
                              )}
                              {details.id === "loco" && (
                                <img
                                  src={details.inlineUrl}
                                  className="position-absolute"
                                  alt=""
                                  style={{
                                    left: 12,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    width: 20,
                                    height: 20,
                                    filter: "drop-shadow(0 0 4px #888)",
                                  }}
                                />
                              )}
                              <input
                                type="text"
                                placeholder={details.value}
                                className="text-white fs-14 height-45 border-0 flex-grow-1"
                                value={details.value}
                                onChange={e => this.updateDetails(e, i)}
                                style={{
                                  backgroundColor: "transparent",
                                  outline: "none",
                                  paddingLeft: 40,
                                }}
                              />
                              <AiOutlineMinusCircle
                                className="btn-size-20 position-absolute cursor-pointer"
                                style={{
                                  right: 10,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "#fff",
                                  filter: "drop-shadow(0 0 4px #888)",
                                  background: "none",
                                  border: "none",
                                  boxShadow: "none",
                                  pointerEvents: "auto",
                                }}
                                onClick={e => {
                                  this.showFields(e, i, false);
                                }}
                              />
                            </div>
                          </div>
                        );
                      }
                    })}

                    <div
                      className="black-flat-btn d-flex flex-row align-items-center justify-content-center mx-auto height-45 rounded-10 mt-2 cursor-pointer"
                      onClick={e => {
                        e.preventDefault();
                        this.setState({ openSocialMediaModal: !this.state.openSocialMediaModal });
                      }}
                    >
                      <button className="btn d-flex flex-row align-items-center justify-content-center">
                        <AiFillPlusCircle className="btn-size-20 text-white" />
                        <p className="fs-16 fw-700 text-white text-center mb-0 ms-2">
                          Add Social Media
                        </p>
                      </button>
                    </div>

                    <div className="my-3">
                      <label htmlFor="platform" className="fs-14 fw-600 text-white mb-1 mb-1">
                        Platforms
                      </label>
                      <div className="row justify-content-evenly">
                        {platformsArray.map((platform, i) => {
                          const isPlatformPresent =
                            this.state.buttonValues?.game?.platforms?.includes(platform.value);
                          if (isPlatformPresent) {
                            return (
                              <div className="col-6" key={i}>
                                <button
                                  className={`pink-skyblue-gradient-btn w-100 height-55 d-flex flex-column align-items-center justify-content-center border-0 mb-3 py-lg-5 ${this.state.buttonValues.platform.includes(platform.name) ? "epz-active-field" : ""}`}
                                  onClick={e => this.handleChange(e, "platform", platform.value, 1)}
                                >
                                  <img src={platform.url} alt={platform.name} />
                                  <p className="text-white fs-12 fw-600 mb-0">{platform.name}</p>
                                </button>
                              </div>
                            );
                          }
                        })}
                        {!this.state.buttonValues?.game && (
                          <p className="text-white fs-12 fw-600">
                            Please select a game to display platforms
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="my-3">
                      <label htmlFor="platform" className="fs-14 fw-600 text-white mb-1 mb-1">
                        Region
                      </label>
                      <div className="">
                        <img
                          src={location}
                          alt=""
                          className="btn-size-20 text-white ms-3 position-absolute"
                          style={{ marginTop: "12px" }}
                        />
                        <Field name="region">
                          {({ field, form }) => (
                            <select
                              {...field}
                              disabled={isUpdate}
                              className="sponsor-dropdown purple-field d-flex align-items-center w-100 border-0 ps-5 text-white fs-14 height-45"
                              onChange={e => {
                                form.setFieldValue(field.name, e.target.value);
                                this.setState({ selectedRegion: e.target.value });
                              }}
                            >
                              <option value="">Select Region</option>
                              {this.state.regions?.map((region, i) => {
                                return (
                                  <option key={i} value={region}>
                                    {region}
                                  </option>
                                );
                              })}
                            </select>
                          )}
                        </Field>
                      </div>
                    </div>

                    <div className="my-3">
                      <div className="">
                        <label
                          htmlFor="custom-btn"
                          className="fs-14 fw-600 text-white mb-1 mb-1 w-100"
                          style={{ maxWidth: "fit-content" }}
                        >
                          Participants Type
                        </label>
                        <button
                          type="button"
                          data-tooltip={
                            requiredObject.INFORMATION_TEXT?.CREATE_TOURNAMENT?.PARTICIPANTS_TYPE ||
                            "Pick team battles or solo face-offs."
                          }
                          className="tooltip-info border-0 bg-transparent"
                        >
                          <BsInfoCircle className="btn-size-12 ms-1 text-white" />
                        </button>
                      </div>

                      <div className="row">
                        <div className="row d-flex justify-content-center">
                          <div className="col-6" style={{ display: isTEAM ? "block" : "none" }}>
                            <button
                              className={`fs-14 fw-600 height-55 rounded-10 d-flex flex-column align-items-center  justify-content-center outline-0 border-0 text-white mb-3 pink-skyblue-gradient-btn w-100 ${this.state.buttonValues?.participant_type === "TEAM" ? "epz-active-field" : ""}`}
                              value="TEAM"
                              onClick={e => this.handleChange(e, "participant_type", "TEAM", 1)}
                            >
                              <div className="d-flex mx-auto" style={{ alignItems: "center" }}>
                                <IoIosPeople className="btn-size-20 text-white" />
                                <p className="text-white fs-12 fw-600 mb-0 mx-2 my-0">Vs</p>
                                <IoIosPeople className="btn-size-20 text-white" />
                              </div>
                            </button>
                          </div>
                          <div className="col-6" style={{ display: isSINGLE ? "block" : "none" }}>
                            <button
                              className={`fs-14 fw-600 height-55 rounded-10 d-flex flex-column align-items-center  justify-content-center outline-0 border-0 text-white mb-3 pink-skyblue-gradient-btn w-100 ${this.state.buttonValues?.participant_type === "SINGLE" ? "epz-active-field" : ""}`}
                              value="SINGLE"
                              onClick={e => this.handleChange(e, "participant_type", "SINGLE", 1)}
                            >
                              <div className="d-flex mx-auto" style={{ alignItems: "center" }}>
                                <FaUserAlt className="btn-size-20 text-white" />
                                <p className="text-white fs-12 fw-600 mb-0 mx-2 my-0">Vs</p>
                                <FaUserAlt className="btn-size-20 text-white" />
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="my-3">
                        <label className="fs-14 fw-600 text-white">
                          Max{" "}
                          {this.state.buttonValues?.participant_type === "TEAM"
                            ? "Teams"
                            : "Participants"}
                        </label>
                        <div className="position-relative">
                          <FaUserAlt
                            className="btn-size-20 text-white-50 mx-2 ms-3 position-absolute"
                            style={{ marginTop: "12px" }}
                          />
                          <Field
                            name="maxParticipants"
                            as="select"
                            className="purple-field d-flex align-items-center w-100 border-0 ps-5 text-white fs-14 height-45"
                            validate={this.maxParticipantVal}
                            onChange={e => {
                              this.saveFormikDetails(e?.target?.value, "maxParticipants", 2);
                            }}
                          >
                            <option value="">Select Max Participants</option>
                            {[2, 4, 8, 16, 32, 64, 128, 256, 512, 1024, 2048].map(val => (
                              <option key={val} value={val}>
                                {val}
                              </option>
                            ))}
                          </Field>
                        </div>
                        <ErrorMessage
                          component="span"
                          className="error-msg"
                          name="maxParticipants"
                        />
                      </div>
                      <div
                        className="my-3"
                        style={{
                          display:
                            this.state.buttonValues?.participant_type === "TEAM" ? "block" : "none",
                        }}
                      >
                        <label className="fs-14 fw-600 text-white">Participant per Team</label>
                        <div className="">
                          <FaUserAlt
                            className="btn-size-20 text-white-50 mx-2 ms-3 position-absolute"
                            style={{ marginTop: "12px" }}
                          />
                          <Field
                            name="participantsPerTeam"
                            as="select"
                            disabled={isUpdate}
                            className="sponsor-dropdown purple-field d-flex align-items-center w-100 border-0 ps-5 text-white fs-14 height-45"
                            onChange={e => {
                              this.saveFormikDetails(e?.target?.value, "participantsPerTeam", 1);
                            }}
                          >
                            {this.state.buttonValues.game &&
                            this.state.buttonValues.game.participantsAllowedPerTeam.length ? (
                              this.state.buttonValues.game.participantsAllowedPerTeam.map(
                                (el, i) => {
                                  return (
                                    <option key={i} value={el}>
                                      {el}
                                    </option>
                                  );
                                }
                              )
                            ) : (
                              <option>{"No Data Found"}</option>
                            )}
                          </Field>
                        </div>
                        <ErrorMessage
                          component="span"
                          className="error-msg"
                          name="participantsPerTeam"
                        />
                      </div>
                    </div>

                    <div className="my-3">
                      <div className="">
                        <label
                          htmlFor="custom-btn"
                          className="fs-14 fw-600 text-white mb-1 w-100"
                          style={{ maxWidth: "fit-content" }}
                        >
                          Competition Type
                        </label>
                        <div
                          data-tooltip={
                            requiredObject.INFORMATION_TEXT?.CREATE_TOURNAMENT.COMPETITION_TYPE ||
                            "Choose between 1v1 duels or free-for-all matches."
                          }
                          className="tooltip-info"
                        >
                          <BsInfoCircle className="btn-size-12 ms-1" />
                        </div>
                      </div>
                      <div className="row d-flex justify-content-center">
                        <div className="col-6" style={{ display: isFFA ? "block" : "none" }}>
                          <button
                            className={`pink-skyblue-gradient-btn w-100 height-55 d-flex align-items-center justify-content-center border-0 ${this.state.buttonValues?.competition_type === "FFA" ? "epz-active-field" : ""}`}
                            onClick={e => this.handleChange(e, "competition_type", "FFA", 1)}
                          >
                            <p className="text-white fs-16 fw-600 mb-0">FFA</p>
                          </button>
                        </div>
                        <div className="col-6" style={{ display: isDUEL ? "block" : "none" }}>
                          <button
                            className={`pink-skyblue-gradient-btn w-100 height-55 d-flex align-items-center justify-content-center border-0 ${this.state.buttonValues?.competition_type === "DUEL" ? "epz-active-field" : ""}`}
                            onClick={e => this.handleChange(e, "competition_type", "DUEL", 1)}
                          >
                            <p className="text-white fs-16 fw-600 mb-0">Duel</p>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-center mt-5">
                    <div className="d-flex flex-column align-items-center mx-4">
                      <button
                        className="round-btn rounded-circle d-flex align-items-center justify-content-center border-0 mx-auto btn-size-40"
                        type="submit"
                      >
                        <BsArrowRight className="black-rock fs-24" />
                      </button>
                      <p className="fs-16 fw-700 text-white text-center">Save</p>
                    </div>
                  </div>
                </Form>
              </Formik>
            </div>
          </section>
        ) : null}

        <Modal show={this.state.openSocialMediaModal} centered dialogClassName="social-media-modal">
          <Modal.Body>
            <div className="p-3">
              <p className="fs-18 fw-bold text-white text-center mb-2">Social Media Details</p>
              <IoIosCloseCircleOutline
                className="close-icon position-absolute"
                style={{ right: "25px", top: "20px" }}
                onClick={() => {
                  this.setState({ openSocialMediaModal: !this.state.openSocialMediaModal });
                }}
              />

              <div className="my-3">
                {this.state.extraDetails.map((details, i) => {
                  if (details.isChecked) {
                    const platformDetails = getPlatformDetails(details.id);
                    const placeholder =
                      details.isChecked && !details.value ? platformDetails.placeholder || "" : "";
                    return (
                      <div className="my-1" key={i}>
                        <div
                          className="purple-field d-flex align-items-center w-100 border-0 position-relative"
                          style={{ paddingRight: "40px" }}
                        >
                          {/* Render React icon based on key, absolutely positioned inside input */}
                          {details.id === "instagram" && (
                            <AiFillInstagram
                              className="position-absolute"
                              style={{
                                left: 12,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: 20,
                                height: 20,
                                color: "#fff",
                                filter: "drop-shadow(0 0 4px #888)",
                              }}
                            />
                          )}
                          {details.id === "facebook" && (
                            <RiFacebookFill
                              className="position-absolute"
                              style={{
                                left: 12,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: 20,
                                height: 20,
                                color: "#fff",
                                filter: "drop-shadow(0 0 4px #888)",
                              }}
                            />
                          )}
                          {details.id === "x" && (
                            <FaXTwitter
                              className="position-absolute"
                              style={{
                                left: 12,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: 20,
                                height: 20,
                                color: "#fff",
                                filter: "drop-shadow(0 0 4px #888)",
                              }}
                            />
                          )}
                          {details.id === "twitch" && (
                            <FaTwitch
                              className="position-absolute"
                              style={{
                                left: 12,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: 20,
                                height: 20,
                                color: "#fff",
                                filter: "drop-shadow(0 0 4px #888)",
                              }}
                            />
                          )}
                          {details.id === "telegram" && (
                            <FaTelegramPlane
                              className="position-absolute"
                              style={{
                                left: 12,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: 20,
                                height: 20,
                                color: "#fff",
                                filter: "drop-shadow(0 0 4px #888)",
                              }}
                            />
                          )}
                          {details.id === "youtube" && (
                            <AiFillYoutube
                              className="position-absolute"
                              style={{
                                left: 12,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: 20,
                                height: 20,
                                color: "#fff",
                                filter: "drop-shadow(0 0 4px #888)",
                              }}
                            />
                          )}
                          {details.id === "loco" && (
                            <img
                              src={details.inlineUrl}
                              className="position-absolute"
                              alt=""
                              style={{
                                left: 12,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: 20,
                                height: 20,
                                filter: "drop-shadow(0 0 4px #888)",
                              }}
                            />
                          )}
                          <input
                            type="text"
                            placeholder={placeholder}
                            className="text-white fs-14 height-45 border-0 flex-grow-1"
                            value={details.value}
                            onChange={e => this.updateDetails(e, i)}
                            style={{
                              backgroundColor: "transparent",
                              outline: "none",
                              paddingLeft: 40,
                            }}
                          />
                          <AiOutlineMinusCircle
                            className="btn-size-20 position-absolute cursor-pointer"
                            style={{
                              right: 10,
                              top: "50%",
                              transform: "translateY(-50%)",
                              color: "#fff",
                              filter: "drop-shadow(0 0 4px #888)",
                              background: "none",
                              border: "none",
                              boxShadow: "none",
                              pointerEvents: "auto",
                            }}
                            onClick={e => {
                              this.showFields(e, i, false);
                            }}
                          />
                        </div>
                        <p className="error-msg">{details.error}</p>
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
              <div className="d-flex flex-wrap justify-content-center my-3">
                {this.state.extraDetails.map((media, i) => {
                  if (!media.isChecked) {
                    return (
                      <button
                        key={i}
                        className="purple-field border-0 rounded-circle d-flex justify-content-center align-items-center btn-size-52 mb-1 mx-1"
                        onClick={e => {
                          this.showFields(e, i, true);
                        }}
                      >
                        {/* Render React icon based on key for add button */}
                        {media.id === "instagram" && (
                          <AiFillInstagram
                            style={{
                              width: "24px",
                              height: "24px",
                              color: "#fff",
                              filter: "drop-shadow(0 0 4px #888)",
                            }}
                          />
                        )}
                        {media.id === "facebook" && (
                          <RiFacebookFill
                            style={{
                              width: "24px",
                              height: "24px",
                              color: "#fff",
                              filter: "drop-shadow(0 0 4px #888)",
                            }}
                          />
                        )}
                        {media.id === "x" && (
                          <FaXTwitter
                            style={{
                              width: "24px",
                              height: "24px",
                              color: "#fff",
                              filter: "drop-shadow(0 0 4px #888)",
                            }}
                          />
                        )}
                        {media.id === "twitch" && (
                          <FaTwitch
                            style={{
                              width: "24px",
                              height: "24px",
                              color: "#fff",
                              filter: "drop-shadow(0 0 4px #888)",
                            }}
                          />
                        )}
                        {media.id === "telegram" && (
                          <FaTelegramPlane
                            style={{
                              width: "24px",
                              height: "24px",
                              color: "#fff",
                              filter: "drop-shadow(0 0 4px #888)",
                            }}
                          />
                        )}
                        {media.id === "youtube" && (
                          <AiFillYoutube
                            style={{
                              width: "24px",
                              height: "24px",
                              color: "#fff",
                              filter: "drop-shadow(0 0 4px #888)",
                            }}
                          />
                        )}
                        {media.id === "loco" && (
                          <img
                            src={media.url}
                            alt={media.id}
                            style={{
                              width: "24px",
                              height: "24px",
                              filter: "drop-shadow(0 0 4px #888)",
                            }}
                          />
                        )}
                      </button>
                    );
                  }
                  return null;
                })}
              </div>
              {this.getAddButton() ? (
                <button
                  className="white-flat-btn d-block fw-bold py-2 px-4 m-auto mt-3 mb-2"
                  type="button"
                  onClick={this.addDetails}
                >
                  Add
                </button>
              ) : (
                ""
              )}
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateTournament);
